import * as React from "react";
const SvgFiRrOm = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-om_svg__a)">
      <path
        fill="#062147"
        d="M13 1.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 13 1.5M14.5 6c.872 0 2.194-.203 2.958-.605.629-.331.81-1.152.366-1.707a1.12 1.12 0 0 0-1.402-.286A5.24 5.24 0 0 1 14 4c-.815 0-2.347-.466-3.08-.954-.226-.15-.512.091-.391.334C11.148 4.629 12.235 6 14.5 6M19 7c-2.347 0-3.286 1.601-4.041 2.887-.428.729-.831 1.416-1.425 1.729-.638.335-1.295.387-2.526.387a4.95 4.95 0 0 0 1.028-3.002c0-2.757-2.243-5-5-5-2.62 0-4.688 2.23-4.774 2.325a1 1 0 1 0 1.477 1.35c.016-.018 1.578-1.675 3.297-1.675 1.654 0 3 1.346 3 3s-1.346 3-3 3H6a1 1 0 1 0 0 2h1c2.206 0 4 1.794 4 4s-1.794 4-4 4H6c-3 0-4.5-2-5.25-3.878-.393-.983-.75-.385-.75-.385v.952c0 2.515 2.5 5.311 5.5 5.311.054.009 1.5 0 1.5 0 3.309 0 6-2.691 6-6a5.98 5.98 0 0 0-1.536-4.004c1.207-.021 2.079-.125 3.001-.611 1.099-.578 1.693-1.592 2.218-2.485.732-1.248 1.168-1.899 2.316-1.899 1.454 0 3 1.928 3 5.5 0 3.388-1.147 5.494-2.993 5.499h-.014c-1.5 0-2.983-1.814-3.493-2.5-.173-.232-.548-.085-.527.203.117 1.68 1.773 4.297 4.023 4.297 2.505 0 5.005-2.06 5.005-7.5C24 9.577 21.484 7 19 7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-om_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOm;
